import { Injectable, NgZone } from '@angular/core';
import { ReplaySubject, zip } from 'rxjs';
import { map, switchMapTo } from 'rxjs/operators';
import { AMapService } from '../../shared/amap.service';
import { LoggerService } from '../../shared/logger/logger.service';
import { PluginLoaderService } from '../../shared/plugin-loader.service';
import { Getter } from '../../base/interfaces';
declare const AMap: any;

const TAG = 'AmapRectangle';

@Injectable()
export class AmapRectangleService implements Getter<AMap.Rectangle> {
  private rectangle: any;
  private rectangle$ = new ReplaySubject<any>(1);
  private editor: any;
  private editor$ = new ReplaySubject<any>(1);

  constructor(
    private amaps: AMapService,
    private logger: LoggerService,
    private ngZone: NgZone,
    private plugins: PluginLoaderService,
  ) {}

  /**
   * è·åç©å½¢
   */
  get() {
    return this.rectangle$.asObservable();
  }

  /**
   * åå»ºç©å½¢ AMap.Rectangle
   * @param options éé¡¹
   */
  create(options: AMap.Rectangle.Options) {
    return this.amaps.get().pipe(
      map(m => {
        options.map = m;
        this.rectangle = this.ngZone.runOutsideAngular(() => new AMap.Rectangle(options));
        this.logger.d(TAG, 'new Rectangle created.');
        this.rectangle$.next(this.rectangle);
        this.rectangle$.complete();
        return this.rectangle;
      }),
    );
  }

  /**
   * éæ¯ç©å½¢
   */
  destroy() {
    this.get().subscribe(m => {
      m.setMap(null);
      this.logger.d(TAG, 'Rectangle destroyed.');
      this.rectangle = null;
    });
  }

  getEditor() {
    // plugin is loading:
    return this.editor$.asObservable();
  }

  /**
   * å è½½ç¼è¾æä»¶
   */
  loadEditor() {
    return this.plugins.load('AMap.RectangleEditor');
  }

  /**
   * åå»ºç¼è¾å¨
   */
  createEditor() {
    return this.loadEditor().pipe(
      switchMapTo(zip(this.amaps.get(), this.get())),
      map(([m, p]) => {
        this.editor = this.ngZone.runOutsideAngular(() => new AMap.RectangleEditor(m, p));
        this.logger.d(TAG, 'new RectangleEditor created.');
        this.editor$.next(this.editor);
        this.editor$.complete();
        return this.editor;
      }),
    );
  }

  /**
   * å¼å³ç¼è¾å¨
   * @param v å¼å³éé¡¹
   */
  toggleEditor(v: boolean) {
    if (v && !this.editor) {
      this.createEditor().subscribe(editor => editor.open());
      return;
    }

    if (this.editor) {
      if (v) {
        this.editor.open();
      } else {
        this.editor.close();
      }
    }
  }
}
